if (!customElements.get('product-description')) {
  customElements.define('product-description', class ProductDescription extends HTMLElement {
    constructor() {
      super()

      this.tabs = Array.from(this.querySelectorAll('.product-description__tab'))
      this.panels = Array.from(this.querySelectorAll('.product-description__panel'))
      this.tabs.forEach((tab) => tab.addEventListener('click', this.onClickHandler.bind(this)))
    }

    onClickHandler(evt) {
      const tab = evt.target
      const index = tab.id.split('product-description__tab-').pop()
      const panel = this.querySelector(`#product-description__panel-${index}`)

      if (panel) {
        this.tabs.forEach((tab) => tab.classList.remove('product-description__tab--active'))
        this.panels.forEach((panel) => panel.classList.remove('product-description__panel--active'))

        tab.classList.add('product-description__tab--active')
        panel.classList.add('product-description__panel--active')
      }
    }
  })
}
